import React, { useEffect, useState } from 'react';
import { Button, Table, Spin } from 'antd';
import axios from 'axios';
import Header from './header.jsx';
import Sidebar from './sidebar.jsx';
import { useNavigate } from 'react-router-dom';

export const InvoiceList = () => {
  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch all invoices
  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        setLoading(true);
        const response = await axios.get('https://ward3-chandrapur-api.palikaapp.com/api/invoice/all');
        setInvoices(response.data);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchInvoices();
  }, []);

  if (loading) {
    return <Spin size="large" className="mt-20 mx-auto" />;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  const columns = [
    {
      title: 'चलानी मिति',
      dataIndex: 'invoiceDate',
      key: 'invoiceDate',
      render: (text) => new Date(text).toLocaleDateString(),
    },
    {
      title: 'पत्रको प्रकार',
      dataIndex: 'pageLength',
      key: 'pageLength',
    },
    {
      title: 'पत्र पठाउने मानिस/सँस्था',
      dataIndex: 'pageSendingPersonOrOrganization',
      key: 'pageSendingPersonOrOrganization',
    },
    {
      title: 'पत्रको ठेगाना',
      dataIndex: 'pageSendingLocation',
      key: 'pageSendingLocation',
    },
    {
      title: 'बिषय',
      dataIndex: 'subject',
      key: 'subject',
    },
  ];
  const rowClassName = (record, index) => {
    return index % 2 === 0 ? 'odd-row' : 'even-row';
  };

  return (
    <div>
      <Header />
      <div className='pt-20'>
      <Sidebar />
      <div className="ml-0 md:ml-56 mt-6 px-4 md:px-6">
        <h1 className="text-2xl font-bold mb-4 p-5">चलानी</h1>

        {/* Button to Add Invoice */}
        <div className="mb-4 flex justify-end">
          <Button
            type="primary"
            className="bg-blue-500 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded"
            onClick={() => navigate('/invoice/add')}
          >
            थप
          </Button>
        </div>

        {/* Table Wrapper for responsiveness */}
        <div className="overflow-x-auto p-5">
          <div className="inline-block min-w-full">
            <Table
              className='custom-table'
              dataSource={invoices}
              columns={columns}
              rowKey="id"
              pagination={false}
              rowClassName={rowClassName}
            />
          </div>
        </div>

      </div>
    </div>
    </div>
  );
};
